// src/components/TableActions.jsx
import { Box } from "@mui/material";
import {
  Visibility as ViewIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Add as AddIcon,
  PlayArrow as PlayIcon,
  ReceiptLong as ReceiptLongIcon,
} from "@mui/icons-material";

import ActionIconButton from "./ActionIconButton";

const TableActions = ({
  onView,
  onInstantiate,
  onEdit,
  onCosts,
  onDelete,
  onCreateTask,
  hideCreate = false,
}) => (
  <Box display="flex" gap={0.75} alignItems="center">
    {onView && (
      <ActionIconButton title="View" tone="teal" onClick={onView}>
        <ViewIcon fontSize="small" />
      </ActionIconButton>
    )}

    {onInstantiate && (
      <ActionIconButton title="Use SOP" tone="gold" onClick={onInstantiate}>
        <PlayIcon fontSize="small" />
      </ActionIconButton>
    )}

    {onCosts && (
      <ActionIconButton title="Costs" tone="gold" onClick={onCosts}>
        <ReceiptLongIcon fontSize="small" />
      </ActionIconButton>
    )}

    {onEdit && (
      <ActionIconButton title="Edit" tone="teal" onClick={onEdit}>
        <EditIcon fontSize="small" />
      </ActionIconButton>
    )}

    {onDelete && (
      <ActionIconButton title="Delete" tone="danger" onClick={onDelete}>
        <DeleteIcon fontSize="small" />
      </ActionIconButton>
    )}

    {!hideCreate && onCreateTask && (
      <ActionIconButton title="Create Task" tone="gold" onClick={onCreateTask}>
        <AddIcon fontSize="small" />
      </ActionIconButton>
    )}
  </Box>
);

export default TableActions;